import Tagify from '@yaireo/tagify'

var input = document.querySelector(".input-tagify");
if (input) {
  var tagify = new Tagify(input, {})
}
